module.exports = __webpack_public_path__ + "static/media/admin_site_logo.3bba9017.png";